import api from "@/lib/api";
import { toast } from "sonner";

export const partnersApi = {
  list: (params) => api.get("/partnerships", { params }).then(r => r.data),
  detail: (id) => api.get(`/partnerships/${id}`).then(r => r.data),
  create: (b) => api.post("/partnerships", b).then(r => r.data),
  update: (id, b) => api.patch(`/partnerships/${id}`, b).then(r => r.data),
  setStatus: (id, status) => api.post(`/partnerships/${id}/status`, { status }).then(r => r.data),
  remove: (id) => api.delete(`/partnerships/${id}`).then(r => r.data),
  mine: () => api.get("/partnerships/mine").then(r => r.data),
  saved: () => api.get("/partnerships/saved").then(r => r.data),
  save: (id) => api.post(`/partnerships/${id}/save`).then(r => r.data),
  unsave: (id) => api.delete(`/partnerships/${id}/save`).then(r => r.data),
  request: (id, message) => api.post(`/partnerships/${id}/request`, { message }).then(r => r.data),
  requestsForOwner: (id) => api.get(`/partnerships/${id}/requests`).then(r => r.data),
  myRequests: () => api.get("/partnership-requests/mine").then(r => r.data),
  actOnRequest: (rid, action) => api.post(`/partnership-requests/${rid}/action`, { action }).then(r => r.data),
  messages: (rid) => api.get(`/partnership-requests/${rid}/messages`).then(r => r.data),
  sendMessage: (rid, body) => api.post(`/partnership-requests/${rid}/messages`, { body }).then(r => r.data),
};

export const pointsApi = {
  config: () => api.get("/points/config").then(r => r.data),
  gate: (feature) => api.post(`/points/gate/${feature}`).then(r => r.data),
  feedView: () => api.post("/points/feed-view").then(r => r.data),
  history: () => api.get("/points/history").then(r => r.data),
  packages: () => api.get("/points/packages").then(r => r.data),
};

/**
 * Charge the caller for a gated feature. Returns true if access granted.
 * If insufficient points, shows toast and returns false; caller should redirect
 * to /buy-points.
 */
export async function gateAccess(feature, onSuccess) {
  try {
    const r = await pointsApi.gate(feature);
    if (r.deducted > 0) toast.success(r.message, { duration: 2500 });
    onSuccess?.(r);
    return true;
  } catch (e) {
    const detail = e.response?.data?.detail;
    if (e.response?.status === 402 && typeof detail === "object") {
      toast.error(detail.message || "Not enough Credits", { duration: 4500 });
      return { insufficient: true, ...detail };
    }
    toast.error("Could not access this feature");
    return false;
  }
}

export const PARTNER_TYPES = [
  { value: "financial_investor", label: "Financial investor" },
  { value: "co_founder", label: "Business co-founder" },
  { value: "marketing", label: "Marketing partner" },
  { value: "technology", label: "Technology partner" },
  { value: "distribution", label: "Distribution partner" },
  { value: "international", label: "International partner" },
  { value: "skills", label: "Skills-based partner" },
  { value: "strategic", label: "Strategic partner" },
];
export const STAGES = [
  { value: "idea", label: "Idea stage" },
  { value: "startup", label: "Startup stage" },
  { value: "early_operation", label: "Early operation" },
  { value: "growing", label: "Growing business" },
  { value: "established", label: "Established" },
  { value: "expansion", label: "Expansion" },
  { value: "international_expansion", label: "International expansion" },
];
export const INDUSTRIES = ["Technology","Agriculture","Education","Health","Finance","Real Estate","Manufacturing","Retail","Services","Media","Energy","Transport","Hospitality","Other"];

export function fmtInvestment(pr) {
  const req = pr?.investment_required;
  if (!req) return "Investment negotiable";
  return `$${Number(req).toLocaleString()} needed`;
}
